import React from 'react';
import { useMediaQuery } from '@mui/material';
import LocaleSwitcher from '../../../../elements/DS_LocaleSwitcher/DS_LocaleSwitcher';
import MenuLinks from './MenuLinks/MenuLinks';
import IconLinks from './IconLinks';
import NavButtons from './NavButtons';

import { StyledMobileBoxDrawer, StyledWrapperMobileVisibleOnly } from './LinksButtonsDrawerStyles';

const MobileDrawer = ({
  menuOne,
  menuOneLabel,
  menuTwo,
  menuTwoLabel,
  directLinks,
  CTAButton,
  loginButton,
  shopLink,
  faqLink,
  chatLink,
}) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme => theme.breakpoints.down('lg'));

  return (
    <StyledMobileBoxDrawer component="nav">
      {isTablet ? (
        <>
          <MenuLinks
            menuOne={menuOne}
            menuOneLabel={menuOneLabel}
            menuTwo={menuTwo}
            menuTwoLabel={menuTwoLabel}
            directLinks={directLinks}
          ></MenuLinks>
          <IconLinks shopLink={shopLink} chatLink={chatLink} faqLink={faqLink} />
          <LocaleSwitcher />
          <StyledWrapperMobileVisibleOnly>
            {isMobile ? <NavButtons CTAButton={CTAButton} loginButton={loginButton} /> : null}
          </StyledWrapperMobileVisibleOnly>
        </>
      ) : null}
    </StyledMobileBoxDrawer>
  );
};

export default MobileDrawer;
